<template>

    <div class="has-margin-top">
        <div class="bp-panel has-no-title" style="min-height: auto">
            <div class="panel-content">
                <div class="is-flex is-align-items-center" style="gap: 10px;">
                    <template v-for="code in locales">
                        <button
                            :key="code"
                            class="homepage-language-flag"
                            :class="{ 'is-selected': code === selectedLocale }"
                            :title="localeNames[code]"
                            @click="$emit('buttonAction', {action: 'switchLocale', element: code})"
                        >
                            <gb-flag
                                :code="getFlag(code)"
                                size="small"
                                iconPath="/assets/img/flags/"
                            />
                        </button>
                    </template>
                    <button
                        v-if="selectedLocale !== 'de_DE'"
                        class="button"
                        @click="$emit('buttonAction', {action: 'retranslate', element: selectedLocale})"
                    >
                        <i class="material-icons">translate</i>&nbsp;Neu übersetzen
                    </button>
                </div>
                <p class="is-small-text mt-2" v-if="selectedLocale !== 'de_DE'">
                    Du bearbeitest die Sprache: <b>{{ localeNames[selectedLocale] }}</b>. Änderungen werden nur für diese Sprache gespeichert.
                </p>
                <p class="is-small-text mt-2" v-else>
                    Beim ersten Wechsel auf eine andere Sprache werden alle Homepage-Texte automatisch per KI übersetzt.
                </p>
            </div>
        </div>
    </div>

</template>

<script>

import {getFlag} from "@utilities/functions";

export default {
    props: {
        component: {
            type: Object,
            required: true,
        },
    },

    data: function () {
        return {
            locales: ['de_DE', 'fr', 'en'],
            localeNames: {
                de_DE: 'Deutsch',
                fr: 'Französisch',
                en: 'Englisch',
            },
        }
    },

    computed: {
        selectedLocale: function () {
            return this.component.props.selectedLocale;
        },
    },

    methods: {
        getFlag,
    },
}
</script>
